export default {
  getChoicesSuccess: 'formsTypes/choices/getChoicesSuccess',
  gettingChoices: 'formsTypes/choices/gettingChoices',
  getChoicesFail: 'formsTypes/choices/getChoicesFail',
};
